<template>
  <NiceView
    :aboveTitle="generalStore.viewHeader"
    :title="CommonService.routes.ORGANIZATIONS.title"
    :icon="CommonService.routes.ORGANIZATIONS.icon"
    :loading="loading"
    flexBody
  >
    <!-- Filters -->
    <NiceFilters v-model="filtersList" @change="filterChanged" :showCreateButton="false" />

    <!-- Table -->
    <NiceTable
      :actions="actions"
      :columns="columns"
      :data="data"
      :loading="loading"
      freezeLastColumn
      showFooter
      showLimit
      paginated
      @filterChange="filterChanged"
    />

    <!-- Form -->
    <NicePanel :name="panelName" @close="closeEdit">
      <OrganizationForm @cancel="closeEdit" @success="successEdit" :data="selectedItem"></OrganizationForm>
    </NicePanel>

    <!-- <pre>{{ data }}</pre> -->
  </NiceView>
</template>

<script setup>
import { ref, computed, inject, watch, onMounted } from "vue";
import CommonService from "@/services/common.service";
import ApiService from "@/services/api/api.service";
import ErrorService from "@/services/error.service";
import StorageService from "@/services/storage.service";
import OrganizationForm from "@/components/forms/OrganizationForm.vue";

import { formatDateWithTime } from "@/plugins/date";
const $getQuery = inject("getQuery");
const $nice = inject("nice");

import { useRoute, useRouter } from "vue-router";
const route = useRoute();
const router = useRouter();

import { useGettext } from "vue3-gettext";
const { $gettext } = useGettext();

import { useGeneralStore } from "@/store/general.store";
const generalStore = useGeneralStore();
const data = computed(() => generalStore.organizations);

const loading = ref(false);
const selectedItem = ref(null);
const panelName = "organization-panel";

// Watch for id change
watch(
  () => route.query,
  () => {
    if (route.query.id) {
      $nice.panel(panelName, true);
    }
  }
);

onMounted(async () => {
  if (route.query.id) {
    if (route.query.id == "new") return $nice.panel(panelName, true);
    try {
      selectedItem.value = await ApiService.organizations.get(route.query.id);
      $nice.panel(panelName, true);
    } catch (e) {
      ErrorService.showError(e);
      closeEdit();
    }
  }
});

function closeEdit() {
  selectedItem.value = null;
  router.push({ query: { ...route.query, id: undefined } });
  $nice.panel(panelName, false);
}

function successEdit() {
  closeEdit();
  getData();
}

// function openEdit(item) {
//   selectedItem.value = item;
//   router.push({ query: { ...route.query, id: item.id } });
// }

async function getData() {
  loading.value = true;
  try {
    const query = await $getQuery();
    await generalStore.getOrganizations(query);
  } catch (e) {
    ErrorService.showError(e);
  } finally {
    loading.value = false;
  }
}

const filtersList = [];

function filterChanged() {
  getData();
}

const actions = [
  {
    icon: () => "icon-arrow-right",
    function: (organization) => {
      StorageService.removeOrganization();
      StorageService.removeEvent();
      generalStore.setEvent(null);
      generalStore.setOrganization(organization);
      router.push({
        name: "app.organizations.events.all",
        params: { organizationId: organization.id },
        query: {},
      });
    },
  },
  // {
  //   icon: () => "icon-edit-3",
  //   function: (item) => openEdit(item),
  // },
];

const columns = [
  {
    name: $gettext("Name"),
    key: "name",
    hasOrder: true,
  },
  {
    name: $gettext("Modules"),
    key: "modules",
    html: (v) => {
      let html = "<div class='badges'>";
      for (const value of v) {
        html += `<div class="badge ${CommonService.getModule(value).class}">${CommonService.getModule(value).name}</div>`;
      }
      return html + "</div>";
    },
    class: "d-xs-none",
    hasOrder: true,
  },
  {
    name: $gettext("Permissions"),
    key: "permissions",
    html: (v) => {
      let html = "<div class='badges'>";
      for (const [key, value] of Object.entries(v)) {
        if (!value) return;
        html += `<div class='badge' class="${CommonService.getPermission(key).class}">${CommonService.getPermission(key).text}</div>`;
      }
      return html + "</div>";
    },
    class: "d-xs-none",
    hasOrder: true,
  },
  {
    name: $gettext("Created at"),
    key: "created_at",
    class: "text-right",
    formatter: (v) => formatDateWithTime(v),
    hasOrder: true,
  },
];
</script>
